module.exports = __webpack_public_path__ + "e5d197ac1e9be52724cbeb314a164f77.png";